import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { environment } from '@environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, ActionReducerMap, MetaReducer, StoreModule } from '@ngrx/store';
import { Logger } from '@shared/services/logging/logger';
import { AppEffects } from '@state/effects/app/app.effects';
import { AuthEffects } from '@state/effects/auth/auth.effects';
import * as fromApp from '@state/reducers/app/app.reducer';
import * as fromAuth from '@state/reducers/auth/auth.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('auth', fromAuth.reducer),
        EffectsModule.forFeature([AppEffects, AuthEffects]),
        StoreModule.forFeature('app', fromApp.reducer)
    ],
    declarations: [],
    exports: [
        StoreModule,
        EffectsModule
    ]
})
export class StateModule { }

export interface IState {
    auth: fromAuth.IAuthState;
    app: fromApp.IAppState;
}

export const reducers: ActionReducerMap<IState> = {
    auth: fromAuth.reducer,
    app: fromApp.reducer
};

export function logger(reducer: ActionReducer<IState>): ActionReducer<IState> {
    return (state: any, action: any): IState => {
        if (!!Logger && !!Logger.sinks[environment.logger.sinks.store.name]) {
            Logger.sinks[environment.logger.sinks.store.name].info('ACTION', action);
        }

        return reducer(state, action);
    };
}

export const metaReducers: Array<MetaReducer<IState>> = !environment.production ? [logger] : [logger];
